import client from "@/client/publicApiClient.ts";
import type { ResponseConfig } from "@/client/publicApiClient.ts";
import type { DoesClientCodeExistQueryResponse, DoesClientCodeExistPathParams } from "../types/DoesClientCodeExist";

 /**
 * @summary Client code check
 * @link /api/sign-up/client-code-check/:clientCode
 */
export async function doesClientCodeExist(clientCode: DoesClientCodeExistPathParams["clientCode"], options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<DoesClientCodeExistQueryResponse>["data"]> {
    const res = await client<DoesClientCodeExistQueryResponse>({ method: "get", url: `/api/sign-up/client-code-check/${clientCode}`, ...options });
    return res.data;
}